module.exports = __webpack_public_path__ + "img/termenecolor.79c4d335.png";